import Home from '@/components/pages/Home'
import About from '@/components/pages/About'
import Services from '@/components/pages/Services'
import Gallery from '@/components/pages/Gallery'
import Contact from '@/components/pages/Contact'
import Privacy from '@/components/pages/Privacy'
import Cookies from '@/components/pages/Cookies'

export default [
  {
    path: '/about/',
    name: 'About',
    component: About,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/services/',
    name: 'Services',
    component: Services,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/gallery/',
    name: 'Gallery',
    component: Gallery,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/contact/',
    name: 'Contact',
    component: Contact,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/privacy-policy/',
    name: 'Privacy',
    component: Privacy,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/cookie-policy/',
    name: 'Cookies',
    component: Cookies,
    pathToRegexpOptions: { strict: true }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    pathToRegexpOptions: { strict: true }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js